import 'babel-polyfill'
import Vue from 'vue'
// import pge from '../passGuard/PassGuardCtrl.js'
// import jQuery from '../passGuard/jquery-1.12.3.min.js'

import Element from 'element-ui'
import '@/styles/theme/index.css'

import App from './App.vue'
import store from './store'
import router from './router'
import './permission' // permission control

import i18n from './lang'
import * as filters from './filters'
import { init } from '@/utils/CryptoKit'

init()
// var pgeditor = new pge.Pge({
//   pgePath: './ocx/', // 控件下载目录，可以指定绝对路径，如"http://www.baidu.com/download/"
//   pgeId: '_ocx_password', // 控件id
//   pgeEdittype: 0, // 控件显示类型,0(星号),1(明文)
//   pgeEreg1: '[\\s\\S]*', // 输入过程中字符类型限制，如"[0-9]*"表示只能输入数字
//   pgeEreg2: '[\\s\\S]{6,12}', // 输入完毕后字符类型判断条件，与pgeditor.pwdValid()方法对应
//   pgeMaxlength: 12, // 允许最大输入长度
//   pgeTabindex: 2, // tab键顺序
//   pgeClass: 'ocx_style', // 控件css样式
//   pgeInstallClass: 'ocx_style', // 针对安装或升级的css样式
//   pgeOnkeydown: 'FormSubmit()', // 回车键响应函数，需焦点在控件中才能响应
//   tabCallback: 'input2', // 火狐tab键回调函数,设置要跳转到的对象ID
//   pgeOnfocus: 'pgeFocus()', // 监控光标切入密码控件框
//   pgeOnblur: 'pgeBlur()', // 监控光标切出密码控件框
//   pgeCert: '3081890281810092D9D8D04FB5F8EF9B8374F21690FD46FDBF49B40EECCDF416B4E2AC2044B0CFE3BD67EB4416B26FD18C9D3833770A526FD1AB66A83ED969AF74238D6C900403FC498154EC74EAF420E7338675CAD7F19332B4A56BE4FF946B662A3C2D217EFBE4DC646FB742B8C62BFE8E25FD5DC59E7540695FA8B9CD5BFD9F92DFAD009D230203010001',
//   // windows10 edge&Chrome42+相关
//   // windows10 edge&Chrome42+相关
//   pgeWindowID: 'password' + new Date().getTime() + 1,
//   // pgeRZRandNum: '44252572466728049961161796923396',
//   // pgeRZDataB: 'uTQHqzrsantP8xX6PLH1hnn8zCJ/A0KlhcRsmQ+h1mM='
//   pgeRZRandNum: '26043592843818248016850281040623',
//   pgeRZDataB: '3kgnuB5r1V4Y045V8haV3+fk08lv7m2oRnZdK0Ss0Jg='
//   // pgeRZRandNum: '<%=sKey%>',
//   // pgeRZDataB: '<%=enStr%>'
// })
// var pgeditor = new pge.Pge({
//   pgePath: './ocx/',
//   pgeId: '_ocx_password',
//   pgeEdittype: 0,
//   pgeEreg1: '[\\s\\S]*',
//   pgeEreg2: '[\\s\\S]{6,12}',
//   pgeMaxlength: 12,
//   pgeTabindex: 2,
//   pgeClass: 'ocx_style',
//   pgeInstallClass: 'ocx_style',
//   pgeOnkeydown: 'FormSubmit()',
//   tabCallback: 'input2',
//   pgeCert: '3081890281810092D9D8D04FB5F8EF9B8374F21690FD46FDBF49B40EECCDF416B4E2AC2044B0CFE3BD67EB4416B26FD18C9D3833770A526FD1AB66A83ED969AF74238D6C900403FC498154EC74EAF420E7338675CAD7F19332B4A56BE4FF946B662A3C2D217EFBE4DC646FB742B8C62BFE8E25FD5DC59E7540695FA8B9CD5BFD9F92DFAD009D230203010001',
//   pgeWindowID: 'password' + new Date().getTime() + 1,
//   pgeRZRandNum: '26043592843818248016850281040623',
//   pgeRZDataB: '3kgnuB5r1V4Y045V8haV3+fk08lv7m2oRnZdK0Ss0Jg='
// })
// window.pgeCtrl = pgeditor
// window.FormSubmit = function() {
//   console.log('密码长度' + pgeditor.pwdLength())
//   pgeditor.pwdSetSk('12345678901234567890123456789012')
//   console.log('miwen:' + pgeditor.pwdResult())
// }

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
// Vue.properties.jQuery = jQuery

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  // jQuery,
  // mounted: function() {
  //   // console.log(pgeditor.load())
  //   // jQuery('#testpass').html(pgeditor.load())
  //   console.log(jQuery('#customer_password'))
  //   // jQuery('#customer_password').html(pgeditor.load())
  //   // jQuery('#customer_password').html('222')
  // },
  render: h => h(App)
})
